import { 
  AfterViewInit, 
  ApplicationRef, 
  Component,   
  ComponentRef,  
  Injector,  
  OnChanges, 
  OnDestroy, 
  SimpleChanges, 
  ViewChild, 
  ViewContainerRef, 
  ViewEncapsulation,
  ComponentFactoryResolver
 } from '@angular/core';
import { SupplierDetailsStepBase, checkValidityEvent } from '../supplier-details/suppliers-details-step-base';
import { ContactsService, DocumentsService, SharedDataService, SuppliersService, PafListsService } from '../../../all-services';
import { ActivatedRoute } from '@angular/router';
import { SaveStepParam,  SupplierRseAnswer, SupplierRseAnswersIndex } from '../../../all-models';
import { SupplierRseAnswers } from './SupplierRseAnswers';
import { NgForm } from '@angular/forms';
import { Observable, of, Subscription } from 'rxjs';
import { RoundedProgressBarComponent } from '../../../all-components';

@Component({
  selector: 'app-supplier-rse',
  templateUrl: './supplier-rse.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./supplier-rse.component.scss']
})
export class SupplierRSEComponent extends SupplierDetailsStepBase implements OnChanges, AfterViewInit, OnDestroy {

  constructor(
    public docsSvc: DocumentsService,
    public sharedDatasSvc: SharedDataService,
    public suppliersSvc: SuppliersService,
    public route: ActivatedRoute,
    public contactsSvc: ContactsService,
    private listsSvc: PafListsService,
    private appRef: ApplicationRef,
    private viewContainerRef: ViewContainerRef,
    private cfr: ComponentFactoryResolver,
    private injector: Injector) {
    super(sharedDatasSvc, docsSvc, suppliersSvc, route, contactsSvc);
  }
  
  private progressBarCompRef?: ComponentRef<RoundedProgressBarComponent>;
  private onChangeValueSub: Subscription = null;

  ngAfterViewInit(): void {
    const factory = this.cfr.resolveComponentFactory(RoundedProgressBarComponent);
    this.progressBarCompRef = this.viewContainerRef.createComponent(factory);
    // this.progressBarCompRef.setInput('max', this.sharedDatasSvc.rseMaxValue);
    // this.progressBarCompRef.setInput('current', this.supplierAnswsers.rseIndictateurValue);
    // this.progressBarCompRef.setInput('color', this.supplierAnswsers.rseIndictateurColor);
    // this.progressBarCompRef.setInput('width', 80);
    // this.progressBarCompRef.setInput('stroke', 5);
    // this.progressBarCompRef.setInput('height', 40);
    // this.progressBarCompRef.setInput('labelCod', 'Note_RSE');
    this.progressBarCompRef.instance.max = this.sharedDatasSvc.rseMaxValue;
    this.progressBarCompRef.instance.current = this.supplierAnswsers.rseIndictateurValue;
    this.progressBarCompRef.instance.color = this.supplierAnswsers.rseIndictateurColor;
    this.progressBarCompRef.instance.width = 80;
    this.progressBarCompRef.instance.stroke = 5;
    this.progressBarCompRef.instance.height = 40;
    this.progressBarCompRef.instance.labelCod = 'Note_RSE';
    this.progressBarCompRef.changeDetectorRef.detectChanges();
    const domElem = this.progressBarCompRef.location.nativeElement;
    const wrapper = document.getElementById('rse-progress-container');
    if (wrapper) wrapper.appendChild(domElem);
  }

  
  private updateProgressInputs() {
    // this.progressBarCompRef?.setInput('current', this.supplierAnswsers.rseIndictateurValue);
    // this.progressBarCompRef?.setInput('color', this.supplierAnswsers.rseIndictateurColor);
    if (!this.progressBarCompRef) return;
    this.progressBarCompRef.instance.current = this.supplierAnswsers.rseIndictateurValue;
    this.progressBarCompRef.instance.color = this.supplierAnswsers.rseIndictateurColor;
    this.progressBarCompRef.changeDetectorRef.detectChanges();
  }

  onValueChanged():void {
    this.updateProgressInputs();
  }

  ngOnDestroy(): void {
    // Nettoyage propre
    if (this.onChangeValueSub != null) {
        this.onChangeValueSub.unsubscribe();
        this.onChangeValueSub = null; 
      }
    if (this.progressBarCompRef) {
      this.appRef.detachView(this.progressBarCompRef.hostView);
      this.progressBarCompRef.destroy();
    }
    super.ngOnDestroy();
  }

 @ViewChild('frmRse') frmRse: NgForm;

  supplierAnswsers?: SupplierRseAnswers;



  private _ShowSaveButton = (): any => {
    if (!this.canModifySupplier()) return false;
    if (!this.sharedDatasSvc.profil) return false;
    return this.sharedDatasSvc.checkProfilAccessPafSettings('RSE');
  }



  get votreEntrepriseDisabled(): boolean {
    if (this.isCreatingSupplier) return false;
    if (!this.canModifySupplier()) return true;
    if (!this.sharedDatasSvc.profil) return false;
    return !this.sharedDatasSvc.checkProfilAccessPafSettings('FICHE_MAJ_VOTRE_ENT');
    //return ['CTRL_QUAL', 'ADMIN'].indexOf(this.sharedDatasSvc.profil?.Cod) < 0;
  }

  onCheckValidity(event:checkValidityEvent):Observable<boolean | undefined>{
    if (event.stepNum!=this.screenValidity.step) return of(undefined);
    event.forms=[this.frmRse];
    let isValid:boolean=true;
    if (!this.supplierAnswsers?.canSave) {
      this.screenValidity.errorMessages.push('Le_questionnaire_RSE_est_incomplet');
      isValid = false;
    }
    return of(isValid);
  }

  get readonly(): boolean {
    if (this.isCreatingSupplier) return false;
    return !this.ocurrentstep.isEditing;
  }

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);
    if (changes['supplier'] && !!this.supplier) {
      if (this.onChangeValueSub != null) {
        this.onChangeValueSub.unsubscribe();
        this.onChangeValueSub = null; 
      }
      this.supplierAnswsers = new SupplierRseAnswers(this.supplier, this.sharedDatasSvc, this.suppliersSvc, this.listsSvc, this.docsSvc);
      this.onChangeValueSub = this.supplierAnswsers.valueChanged.subscribe(()=> this.updateProgressInputs());
    }
    if (changes['ocurrentstep']) {
      setTimeout(() => {
        this.ocurrentstep.showSaveButton = (): boolean => { return this._ShowSaveButton() };
      }, 0);
    }
  }
  

  save(param: SaveStepParam): void {
    if (param.nextAction == 'forceScreen') {
      super.save(param);
      return;
    }
    this.CanSave(this.frmRse, param);
    if (!param.canSave && !param.noSaveAllowed(this.currentStep)) return;
    this.sharedDatasSvc.WindowLock();
    this.supplierAnswsers.save()
      .subscribe({
        next: (results: SupplierRseAnswer[]) => {
            this.supplierAnswsers.sendPendingFiles(results).subscribe({
            next:(results2:SupplierRseAnswersIndex[]) =>{
                results2.forEach(item=>{
                  let supplierIdx:SupplierRseAnswersIndex =this.supplier.SupplierRseAnswers.find(r=>r.Id==item.AnswerId)?.SupplierRseAnswersIndexes.find(i=>i.Id==item.Id);
                  if (supplierIdx) supplierIdx.Value = item.Value;
                });
                this.sharedDatasSvc.WindowUnlock();
                super.save(param);
            },
            error: (reason)=> {
              this.sharedDatasSvc.WindowUnlock();
              this.sharedDatasSvc.alert(reason.error.Message);
            }
          });                
        },
        error: (reason) => {
          this.sharedDatasSvc.WindowUnlock();
          this.sharedDatasSvc.alert(reason.error.Message);
        }
      });
  }


}


